import { DOCUMENT } from '@angular/common';

import { Injectable, inject } from '@angular/core';

import { NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs';



import { environment } from '../../../../environments/environment';



declare global {

  interface Window {

    dataLayer: unknown[];

    gtag?: (...args: unknown[]) => void;

  }

}



/*

 * Google Analytics 4 (gtag.js) wrapper. Loads the gtag script once at app start when

 * environment.gaMeasurementId is set; an empty ID leaves analytics fully disabled.

 * Page views are sent on every Router NavigationEnd (including the first load), because GA4's

 * automatic history-change detection does not reliably catch Angular route changes.

 * Keep "Page changes based on browser history events" OFF in the GA4 stream to avoid double counting.

 */

@Injectable({

  providedIn: 'root',

})

export class AnalyticsService {

  private readonly document = inject(DOCUMENT);

  private readonly router = inject(Router);

  private readonly measurementId = environment.gaMeasurementId;



  init(): void {

    const win = this.document.defaultView;

    if (!this.measurementId || !win || win.gtag) {

      return;

    }



    const script = this.document.createElement('script');

    script.async = true;

    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;

    this.document.head.appendChild(script);



    win.dataLayer = win.dataLayer || [];

    const dataLayer = win.dataLayer;

    // gtag.js only recognises commands pushed as the native `arguments` object; a rest-parameter array is ignored.

    function gtag(): void {

      // biome-ignore lint/style/noArguments: required by gtag.js

      dataLayer.push(arguments); // NOSONAR

    }

    win.gtag = gtag;

    win.gtag('js', new Date());

    win.gtag('config', this.measurementId, { send_page_view: false });



    this.router.events

      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))

      .subscribe(event => {

        win.gtag?.('event', 'page_view', {

          page_location: `${win.location.origin}${event.urlAfterRedirects}`,

        });

      });

  }



  trackEvent(name: string, params?: Record<string, unknown>): void {

    this.document.defaultView?.gtag?.('event', name, params);

  }

}

